import {
  CARGAR_SHOPPING_DESPACHO_EXITO
} from './actions';

export const shopping_despacho = (state = {}, action) => {
  switch (action.type) {
    case CARGAR_SHOPPING_DESPACHO_EXITO:
      return Object.assign({}, action.shopping_despacho);
    default:
      return state;
  }
};
